import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaFacebook, FaInstagram, FaWhatsapp, FaTiktok } from 'react-icons/fa';
import { FiMail, FiSend, FiPhone } from 'react-icons/fi';

const Footer = () => {
    const [email, setEmail] = useState('');

    const handleNewsletterSubmit = (e) => {
        e.preventDefault();
        // Open email client with subscription request
        const subject = 'Newsletter Subscription';
        const body = `I would like to subscribe to WallZ newsletter with this email: ${email}`;
        window.location.href = `mailto:wallz.egy@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        setEmail('');
    };

    return (
        <footer className="footer">
            <div className="footer-content">
                {/* Brand Section */}
                <div className="footer-section footer-brand">
                    <div className="footer-logo">

                        WallZ
                    </div>
                    <p className="footer-description">
                        Transform your space with our curated collection of premium wall art.
                        From minimalist designs to bold statements, find the perfect piece for your home.
                    </p>
                    <div className="footer-contact-info">
                        <a href="tel:01112659808" className="contact-item">
                            <FiPhone />
                            <span>01112659808</span>
                        </a>
                        <a href="mailto:wallz.egy@gmail.com" className="contact-item">
                            <FiMail />
                            <span>wallz.egy@gmail.com</span>
                        </a>
                    </div>
                    <div className="footer-social">
                        <a href="https://www.instagram.com/wallz_eg/" target="_blank" rel="noreferrer" className="social-icon">
                            <FaInstagram />
                        </a>
                        <a href="https://www.facebook.com/profile.php?id=61578285524597" target="_blank" rel="noreferrer" className="social-icon">
                            <FaFacebook />
                        </a>
                        <a href="https://www.tiktok.com/@wallz.eg" target="_blank" rel="noreferrer" className="social-icon">
                            <FaTiktok />
                        </a>
                        <a href="https://wa.me/201112659808" target="_blank" rel="noreferrer" className="social-icon">
                            <FaWhatsapp />
                        </a>
                    </div>
                </div>

                {/* Quick Links */}
                <div className="footer-section">
                    <h3>Quick Links</h3>
                    <div className="footer-links">
                        <Link to="/">Home</Link>
                        <Link to="/shop">Shop All</Link>
                        <Link to="/collections">Collections</Link>
                        <Link to="/cart">Shopping Cart</Link>
                    </div>
                </div>

                {/* Support */}
                <div className="footer-section">
                    <h3>Support</h3>
                    <div className="footer-links">
                        <Link to="/contact">About Us</Link>
                        <Link to="/contact">Contact</Link>
                        <Link to="/contact">Shipping Info</Link>
                        <Link to="/contact">Returns</Link>
                        <Link to="/contact">Privacy Policy</Link>
                    </div>
                </div>

                {/* Newsletter */}
                <div className="footer-section">
                    <h3>Stay Updated</h3>
                    <p className="footer-description" style={{ marginBottom: '16px' }}>
                        Subscribe to get special offers and updates.
                    </p>
                    <form onSubmit={handleNewsletterSubmit} className="footer-newsletter">
                        <input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="newsletter-input"
                            required
                        />
                        <button type="submit" className="newsletter-btn">
                            <FiSend style={{ marginRight: '8px' }} />
                            Subscribe
                        </button>
                    </form>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="footer-bottom">
                <div className="footer-copyright">
                    © {new Date().getFullYear()} <span>WallZ</span>. All rights reserved.
                </div>
                <div className="footer-links-bottom">
                    <Link to="/contact">Privacy Policy</Link>
                    <Link to="/contact">Terms of Service</Link>
                    <Link to="/contact">Shipping Policy</Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
